import { webViewLayer } from "../../../../utils/webViewLayer";
import type { ICredentials } from "../../../../utils/credentialsStore";

// a drive app without the marker keeps the ended session, so its native syncs would stop until the next login
export function canReplaceNativeSession(): boolean {
    return typeof window.ReactNativeWebView?.postMessage !== "function" || window.geotabModules?.user?.canReplaceSession === true;
}

// a password change ends every session, including the one the native app holds
export function replaceNativeSession(credentials: ICredentials, server: string): void {
    if (!credentials.sessionId) {
        return;
    }

    webViewLayer.sessionEstablished({
        server,
        database: credentials.database,
        userName: credentials.userName,
        sessionId: credentials.sessionId,
        replacesSession: true
    });
}
